<script setup lang="ts">
import { IconBrandAndroid, IconBrandApple } from '@tabler/icons-vue';
import Button from '~/components/button.vue';
const layoutStore = useLayoutStore();
</script>

<template>
    <div class="flex flex-col sm:hidden min-h-screen bg-white dark:bg-zinc-800">
        <div class="flex-1 flex flex-col items-center justify-center px-6 py-12">
            <h1 class="text-xl font-medium text-center mb-2 text-zinc-900 dark:text-zinc-50">
                Use Pipeback on your phone
            </h1>

            <p class="text-zinc-500 dark:text-zinc-400 text-center mb-8 text-base">
                Download the app to get started
            </p>

            <div class="w-full max-w-sm space-y-4">
                <Button class="w-full btn btn-primary btn-lg space-x-2" :href="layoutStore.ios" target="_blank">
                    <IconBrandApple class="size-6" />
                    <span>Download for iOS</span>
                </Button>
                <Button class="w-full btn btn-secondary space-x-2 btn-lg" :href="layoutStore.android" target="_blank">
                    <IconBrandAndroid class="size-6" />
                    <span>Download for Android</span>
                </Button>
            </div>
        </div>
    </div>
</template>